import React, { ReactNode } from 'react';
import Wrapper from './styles';

interface Props {
    children: ReactNode;
}

export default function ResponsibleGamingLimitRow({ children }: Props) {
    return <Wrapper>{children}</Wrapper>;
}
